export default __webpack_public_path__ + "static/Selim-9b3e04fb98c2d5823e4eb6df732d089b.webp";